import {useCallback} from 'react';

import {ONBOARDING_WELCOME_EVENTS} from '@/app/auth/events/WelcomeEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewOnboardingScreen = useCallback(() => {
    trackEvent(ONBOARDING_WELCOME_EVENTS.VIEW_ONBOARDING_SCREEN, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  return {
    trackViewOnboardingScreen,
  };
};
